import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMemberInvitationsKey } from '../../utils/keys';
export const useInviteMembers = (options) => {
    const { useMutationOptions, fields = 'basic' } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation((input) => client.invitations.invite(input, fields), {
        onSettled: () => {
            const memberInvitationsKey = getMemberInvitationsKey();
            queryClient.invalidateQueries(memberInvitationsKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useInviteMembers.js.map